import {useEffect} from 'react'
import {CalculateDistract, TItems} from '../../../../coreGlobal/models/sale'
import {formatMonetaryToBr, removeMask} from '../../../../utils/formatMonetaryToBr'
interface CancelItemsTableProps {
  itemsState: CalculateDistract
  selectedItems: number[]
  setSelectedItems: (items: number[]) => void
  totalPaidValue: number
  discount: number
  hasFine: boolean
  amountFine: number
  setTotalAdjustedValue: (val: number) => void
  setResidualValue: (val: number) => void
  setItemsState: React.Dispatch<React.SetStateAction<CalculateDistract>>
}

const CancelItemsTable = ({
  itemsState,
  selectedItems,
  setSelectedItems,
  totalPaidValue,
  discount,
  hasFine,
  amountFine,
  setTotalAdjustedValue,
  setResidualValue,
  setItemsState,
}: CancelItemsTableProps) => {
  useEffect(() => {
    let totalValue = 0

    const updatedItems = itemsState.items?.map((item) => {
      const deducted = item.remainingSessionsValue * (discount / 100)
      const adjusted = item.remainingSessionsValue - deducted
      const found = selectedItems.includes(item.saleItemId)
      if (found) totalValue += adjusted

      return {
        ...item,
        adjustedValue: parseFloat(adjusted.toFixed(2)),
        deductedValue: parseFloat(deducted.toFixed(2)),
      }
    })

    setItemsState((prev) => ({
      ...prev,
      items: updatedItems,
    }))

    setTotalAdjustedValue(totalValue)

    let result = itemsState.saleAmount - totalValue - removeMask(totalPaidValue)
    if (hasFine) result += amountFine

    setResidualValue(Number(result.toFixed(2)))
  }, [selectedItems, discount, hasFine, amountFine, totalPaidValue])

  const handleCheck = (checked: boolean, id: number) => {
    if (checked) {
      setSelectedItems([...selectedItems, id])
    } else {
      setSelectedItems(selectedItems.filter((i) => i !== id))
    }
  }

  let totalSessionsValue = 0
  let totalContractValue = 0
  let totalRemainingSessionsValue = 0
  let totalDeductedValue = 0
  let totalTableAdjustedValue = 0

  const calulateTableTotal = (item: TItems) => {
    totalSessionsValue += Number(item.sessionsRealizedValue)
    totalContractValue += Number(item.totalValue)
    totalRemainingSessionsValue += Number(item.remainingSessionsValue)
    totalDeductedValue += Number(item.deductedValue)
    totalTableAdjustedValue += Number(item.adjustedValue)
  }

  return (
    <div className='table-responsive'>
      <h4>Item(s) a serem cancelados</h4>
      <table className='table table-row-dashed table-row-gray-300 gy-7'>
        <thead>
          <tr className='fw-bolder fs-6 text-gray-800'>
            <th></th>
            <th>ID</th>
            <th>Nome</th>
            <th>Sessão</th>
            <th>Realizadas</th>
            <th>Pendente</th>
            <th>Valor Utilizado</th>
            <th>Total</th>
            <th>Valor pendente</th>
            <th>Taxa ADM</th>
            <th>Restituição</th>
          </tr>
        </thead>
        <tbody>
          {itemsState.items?.map((item) => {
            calulateTableTotal(item)
            return (
              <tr key={`item-${item.saleItemId}`}>
                <td>
                  {item.sessionsRealized !== item.sessions && (
                    <div className='form-check'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        checked={selectedItems.includes(item.saleItemId)}
                        onChange={(e) => handleCheck(e.target.checked, item.saleItemId)}
                      />
                    </div>
                  )}
                </td>
                <td>{item.saleItemId}</td>
                <td>{item.productName}</td>
                <td>{item.sessions}</td>
                <td>{item.sessionsRealized}</td>
                <td>{item.remainingSessions}</td>
                <td>{formatMonetaryToBr(item.sessionsRealizedValue)}</td>
                <td>{formatMonetaryToBr(item.totalValue)}</td>
                <td>{formatMonetaryToBr(item.remainingSessionsValue)}</td>
                <td>{formatMonetaryToBr(item.deductedValue)}</td>
                <td>{formatMonetaryToBr(item.adjustedValue)}</td>
              </tr>
            )
          })}
          <tr>
            <td>
              <b>Totais</b>
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              <b>{formatMonetaryToBr(totalSessionsValue)}</b>
            </td>
            <td>
              <b>{formatMonetaryToBr(totalContractValue)}</b>
            </td>
            <td>
              <b>{formatMonetaryToBr(totalRemainingSessionsValue)}</b>
            </td>
            <td>
              <b>{formatMonetaryToBr(totalDeductedValue)}</b>
            </td>
            <td>
              <b>{formatMonetaryToBr(totalTableAdjustedValue)}</b>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default CancelItemsTable
